import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UserDetailComponent } from '../user/user-detail/user-detail.component';
import { HttpErrorResponse } from '@angular/common/http';
import { UserService } from '../shared/user.service';
import { TripService } from '../service/trip.service';
import { Cycle, Payment, Site, SpecialMethodPayment } from '../model/trip';
import { ActivatedRoute } from '@angular/router';
import { SelectItem } from 'primeng/primeng';
import { ConfirmationService } from 'primeng/api';

@Component({
  providers: [UserDetailComponent, ConfirmationService],
  selector: 'trip-cycle-details-2',
  templateUrl: './trip-cycle-details-2.component.html',
  styleUrls: ['./trip-cycle-details-2.component.css']
})
export class TripCycleDetails2Component implements OnInit {

  @Input() userDetails: any;
  @Input() selectedSite: Site = null;

  //selectedTid: number;
  selectedCatid: number;
  selectedSid: number;
  selectedCid: number;
  selectedStatusid: number; 
  selectedGrouperName: string;

  @Output() closeDetails: EventEmitter<any> = new EventEmitter();

  msgs: any[] = [];
  //selectedCycle: Cycle = null;
  paymentsOriginal: Payment[];
  paymentsFiltered: Payment[];
  cols: any[];
  isAllChecked: boolean = false;
  isActionButtonsDisabled: boolean = false;
  siteName: string;
  showChangeCardDialog: boolean = false;
  changeCardPaymentDetails: Payment = null;
  showNumOfPaymentsDialog: boolean = false;
  changeNumOfPaymentsDetails: Payment = null;
  numOfPaymentsArray: number[];
  selectedNumOfPayments?: number = null;

  currentRate: number;
  currentMustBeConverted: boolean = false;
  currentCycleCurrency: string = null;

  billingStatuses: SelectItem[] = [
    {value: 0, label: 'טרם בוצע'},
    {value: 1, label: 'בוצע'},
    {value: 2, label: 'תקלה'},
    {value: 9, label: 'נדרש טיפול'},
  ];
  selectedBillingStatusId: number = null;

  cancelOptions: SelectItem[] = [
    {value: 0, label: 'פעיל'},
    {value: 1, label: 'תשלום מבוטל'},
    {value: 3, label: 'שולם אך השתתפות מבוטלת'},
  ];
  selectedCancel: number = null;

  paymentsExecuted: SelectItem[] = [
    {value: 0, label: '0'},
    {value: 1, label: '1'},
    {value: 2, label: '2'},
    {value: 3, label: '3'},
    {value: 4, label: '4'},
    {value: 99, label: 'יותר מ-4'},
  ]
  selectedPaymentsExecuted: number = null;

  Payment_Special_Method1: number = 1;
  showSpecialPaymentsMethod1: boolean = false;
  currentSpecialMethodPaymentItem: Payment = null;

  constructor(private userService: UserService, private tripService: TripService, private route:ActivatedRoute, private confirmationService: ConfirmationService) { }

  ngOnInit() {

  }

  clearData() {
    this.paymentsOriginal = null;
    this.paymentsFiltered = null;
  }

  fillData(catId: number, sId: number, cId: number, statusId: number, grouper: string, mustBeConverted: boolean, cycleCurrency: string, rate: number) {
    console.log(this.billingStatuses);
    
    this.selectedCatid = catId;
    this.selectedSid = sId;
    this.selectedCid = cId;
    this.selectedStatusid = statusId;
    this.selectedGrouperName = grouper;

    this.currentCycleCurrency = cycleCurrency;
    this.currentMustBeConverted = mustBeConverted;
    this.currentRate = rate;

    
    this.paymentsOriginal = null;
    this.paymentsFiltered = null;
    //this.selectedCycle = null;

    


    // if (mustBeConverted) {
    //   this.cols = [
    //     { field: 'RegistrationId', header: 'מספר הזמנה', width: '70', priority: '', visibleByRatesOnly: false },
    //     { field: 'TravelersInPayment', header: 'תשלום עבור משתתפים', width: '120', priority: '' },
    //     { field: 'CardName', header: 'כרטיס', width: '100', priority: '' },
    //     { field: 'CreditCardAmount', header: 'סכום' + ' ' + '(' + cycleCurrency + ')', width: '70', priority: '' },
    //     { field: 'AmountNISPayed', header: 'חוייב בשקלים', width: '100', priority: '', visibleByRatesOnly: true },
    //     { field: 'AmountNISWillBePayed', header: 'יחוייב בשקלים', width: '100', priority: '', visibleByRatesOnly: true },
    //     { field: 'NumOfPayments', header: 'מספר תשלומים', width: '80', priority: '' },
    //     { field: 'CardOwnerID', header: 'ת.ז. בעל הכרטיס', width: '100', priority: '' },
    //     { field: 'CardValidity', header: 'תוקף', width: '70', priority: '' },
    //     { field: 'VfInternalDealNumber', header: 'מספר עסקה', width: '90', priority: '' },
    //     { field: 'BillingStatus', header: 'סטטוס חיוב', width: '110', priority: '' },
    //     { field: 'BillingStatusDate', header: 'תאריך סטטוס', width: '90', priority: '' },
    //     { field: 'BillingLastErrorDescription', header: 'שגיאה אחרונה', priority: '' },
    //   ];
    // } else {
    //   this.cols = [
    //     { field: 'RegistrationId', header: 'מספר הזמנה', width: '70', priority: '', visibleByRatesOnly: false },
    //     { field: 'TravelersInPayment', header: 'תשלום עבור משתתפים', width: '120', priority: '' },
    //     { field: 'CardName', header: 'כרטיס', width: '100', priority: '' },
    //     { field: 'CreditCardAmount', header: 'סכום', width: '70', priority: '' },
    //     //{ field: 'AmountNISPayed', header: 'חוייב בשקלים', width: '70', priority: '', visibleByRatesOnly: true },
    //     //{ field: 'AmountNISWillBePayed', header: 'יחוייב בשקלים', width: '70', priority: '', visibleByRatesOnly: true },
    //     { field: 'NumOfPayments', header: 'מספר תשלומים', width: '70', priority: '' },
    //     { field: 'CardOwnerID', header: 'ת.ז. בעל הכרטיס', width: '100', priority: '' },
    //     { field: 'CardValidity', header: 'תוקף', width: '70', priority: '' },
    //     { field: 'VfInternalDealNumber', header: 'מספר עסקה', width: '90', priority: '' },
    //     { field: 'BillingStatus', header: 'סטטוס חיוב', width: '110', priority: '' },
    //     { field: 'BillingStatusDate', header: 'תאריך סטטוס', width: '90', priority: '' },
    //     { field: 'BillingLastErrorDescription', header: 'שגיאה אחרונה', priority: '' },
    //   ];
    // }

    this.tripService.getPayments2(this.selectedSid, this.selectedGrouperName, this.selectedCid).subscribe((result: any) => {
      

      this.cols = [
        { field: 'RegistrationId', header: 'מספר הזמנה', width: '70', priority: '', visibleByRatesOnly: false }
      ];

      if (!this.selectedGrouperName) {
        // check for only single grouper in data
        let showGrouperColumn = false;
        if (result && result.length>0) {
          let firstGrouper = result[0].CycleGrouper;
          let itemForGrouper = result.filter(f=>f.CycleGrouper==firstGrouper);
          if (itemForGrouper.length<result.length) {
            showGrouperColumn = true;
          }

        }
        if (showGrouperColumn) {
          this.cols.push({ field: 'CycleGrouper', header: 'מקבץ', width: '100', priority: '' });
        }
      }
      if (!this.selectedCid) {
        //  // check for only single grouper in data
        //  let showCycleColumn = false;
        //  if (result && result.length>0) {
        //    let firstCycleId = result[0].CycleId;
        //    let itemForCycle = result.filter(f=>f.CycleId==firstCycleId);
        //    if (itemForCycle.length<result.length) {
        //     showCycleColumn = true;
        //    }
 
        //  }
        //  if (showCycleColumn) {
        //     this.cols.push({ field: 'CycleName', header: 'שם מחזור', width: '200', priority: '' });
        //  }
        this.cols.push({ field: 'CycleName', header: 'שם מחזור', width: '120', priority: '' });
      }

      this.cols.push({ field: 'TravelersInPayment', header: 'תשלום עבור משתתפים', width: '120', priority: '' });
      this.cols.push({ field: 'CardName', header: 'כרטיס', width: '60', priority: '' });
      this.cols.push({ field: 'CreditCardAmount', header: 'סכום' + ' ' + '(' + cycleCurrency + ')', width: '70', priority: '' });

      if (mustBeConverted && !this.selectedSite.SpecialPaymentMethodId) {
        this.cols.push({ field: 'AmountNISPayed', header: 'חוייב בשקלים', width: '100', priority: '', visibleByRatesOnly: true });
        this.cols.push({ field: 'AmountNISWillBePayed', header: 'יחוייב בשקלים', width: '100', priority: '', visibleByRatesOnly: true });
      } else {

      }

      if (this.selectedSite.SpecialPaymentMethodId && this.selectedSite.SpecialPaymentMethodId == this.Payment_Special_Method1) {
        this.cols.push({ field: 'SpecialPayment_NumberOfPaymentsPlaned', header: 'מספר חיובים מתוכננים', width: '60', priority: '', visibleByRatesOnly: true, isSpecialMethodCol: true });
        this.cols.push({ field: 'SpecialPayment_NumberOfPaymentsExecuted', header: 'מספר חיובים שחוייבו', width: '60', priority: '', visibleByRatesOnly: true, isSpecialMethodCol: true });
        this.cols.push({ field: 'SpecialPayment_TotalAmountPayedInCurrency', header: 'סך חיובים שחוייבו (' + cycleCurrency + ')', width: '60', priority: '', visibleByRatesOnly: true, isSpecialMethodCol: true });
        this.cols.push({ field: 'SpecialPayment_WholeReminderInCurrency', header: 'יתרה (' + cycleCurrency + ')', width: '60', priority: '', visibleByRatesOnly: true, isSpecialMethodCol: true });
        this.cols.push({ field: 'SpecialPayment_TotalAmountPayedInNIS', header: 'סך חיובים שחוייבו (' + 'ש"ח' + ')', width: '60', priority: '', visibleByRatesOnly: true, isSpecialMethodCol: true });
        this.cols.push({ field: 'SpecialPayment_AmountNextInCurrency', header: 'חיוב הבא (' + cycleCurrency + ')', width: '60', priority: '', visibleByRatesOnly: true, isSpecialMethodCol: true });
        this.cols.push({ field: 'SpecialPayment_AmountNextInNIS', header: 'חיוב הבא (' + 'ש"ח' + ')', width: '60', priority: '', visibleByRatesOnly: true, isSpecialMethodCol: true });
      }


      this.cols.push({ field: 'CardOwnerID', header: 'ת.ז. בעל הכרטיס', width: '100', priority: '' });
      this.cols.push({ field: 'CreditCardNumber', header: 'כרטיס', width: '50', priority: '' });
      this.cols.push({ field: 'CardValidity', header: 'תוקף', width: '70', priority: '' });
      this.cols.push({ field: 'VfInternalDealNumber', header: 'מספר עסקה', width: '90', priority: '' });
      this.cols.push({ field: 'BillingStatus', header: 'סטטוס חיוב', width: '110', priority: '' });
      this.cols.push({ field: 'BillingStatusDate', header: 'תאריך סטטוס', width: '90', priority: '' });
      this.cols.push({ field: 'BillingLastErrorDescription', header: 'שגיאה אחרונה', /*width: '200', */ priority: '' });
      
      this.paymentsOriginal = result;
      this.filterPayments();
    },
      (err: HttpErrorResponse) => {
        this.showMessage('error', '', 'שגיאה בקבלת נתוני תשלומים');
      });
  }

  backToCycles() {
    //this.selectedCycle = null;
    this.paymentsOriginal = null;
    this.paymentsFiltered = null;
    this.closeDetails.emit();
  }

  toggleAll(event) {
    for (let i = 0; i < this.paymentsFiltered.length; i++) {
      if (this.paymentsFiltered[i].AllowedToSelect) {
        this.paymentsFiltered[i].Selected=this.isAllChecked;
      }
    }
  }

  getSelectedRowsCount(p) {
    if (p) {
      var res = p.filter(f=>f.Selected);
      return res.length;
    } else {
      return null;
    }
  }

  chargeAll() {
    
    if (this.getSelectedRowsCount(this.paymentsFiltered)==0) {
      this.showMessage('warn', '', 'נא לסמן לפחות תשלום אחד לביצוע החיוב');
      return;
    }
    this.isActionButtonsDisabled = true;
    let paymentsDummy: Payment[] = this.paymentsFiltered.filter(f=>f.Selected);
    this.tripService.charge2(paymentsDummy).subscribe((result: any) => {
      this.isAllChecked = false;
      this.paymentsFiltered = null;
      this.isActionButtonsDisabled = false;
      this.fillData(this.selectedCatid,this.selectedSid, this.selectedCid,this.selectedStatusid,this.selectedGrouperName,this.currentMustBeConverted,this.currentCycleCurrency, this.currentRate );
      
    },
      (err: HttpErrorResponse) => {
        this.isActionButtonsDisabled = false;
        this.showMessage('error', '', 'תקלה בביצוע פעולת חיוב');
    });
  }

  chargeSingle(payment: Payment) {
    this.isActionButtonsDisabled = true;
    let p = this.clone(payment);
    p.Selected = true;
    let paymentsDummy: Payment[] = [p];
    
    this.tripService.charge2(paymentsDummy).subscribe((result: any) => {
      this.isAllChecked = false;
      this.paymentsOriginal = null;
      this.paymentsFiltered = null;
      this.isActionButtonsDisabled = false;
      this.fillData(this.selectedCatid,this.selectedSid, this.selectedCid,this.selectedStatusid,this.selectedGrouperName,this.currentMustBeConverted,this.currentCycleCurrency, this.currentRate );

    },
      (err: HttpErrorResponse) => {
        this.isActionButtonsDisabled = false;
        this.showMessage('error', '', 'תקלה בביצוע פעולת חיוב');
    });
  }

  getStatusClass(item: Payment) {
    if (item.BillingStatusId==1 || item.BillingManualStatusId==1) {
      return 'status-success';
    } else if (item.BillingStatusId==2 && item.BillingManualStatusId!=1) {
      return 'status-failure';
    } else {
      return 'status-no';
    }

  }

  getStatusClassFilter(billingStatusId: number) {
    if (billingStatusId==1) {
      return 'filter-status-success';
    } else if (billingStatusId==2) {
      return 'filter-status-failure';
    } else if (billingStatusId==9) {
      return 'filter-status-treat';
    } else {
      return 'filter-status-no';
    }

  }

  getCancelClassFilter(cancelation: number) {
    if (cancelation==0) {
      return 'filter-cancel-active';
    } else if (cancelation==1 || cancelation==3) {
      return 'filter-cancel-canceled';
    } else {
      return 'filter-cancel-no';
    }

  }

  getPaymentOrRefundCalss(item: Payment) {
    if (item.PaymentOrRefund == 2) {
      return 'is-refund';
    } else {
      return '';
    }
  }
 
  showMessage(type, summaryMessage, message): void {
    this.msgs = [];
    this.msgs.push({ severity: type, summary: summaryMessage, detail: message });
  }



  changeCard(payment: Payment) {
    this.showChangeCardDialog = true;
    this.changeCardPaymentDetails = payment;
    console.log(this.changeCardPaymentDetails);
  }
  onHideChangeCardPaymentDetails() {
    this.changeCardPaymentDetails = null;
  }

  changeWholeReminder(payment: Payment) {
    let rem: number = payment.CreditCardAmount-payment.SpecialPayment_TotalAmountPayedInCurrency;
    let remNis: string = payment.SpecialPayment_WholeReminderInNIS?payment.SpecialPayment_WholeReminderInNIS.toString():'';
    remNis = remNis + (remNis?'₪':'');
    this.confirmationService.confirm({
        key: 'confirm1',
        message: //'!!! בשלב זה פעולת החיוב לא מתבצעת !!! ' + 
                 'האם ברצונך לבצע חיוב של היתרה במלואה? ' + 'היתרה היא ' + rem.toString() + payment.CycleCurrency + ' (' + remNis + ')' ,
        header: 'חיוב יתרה במלואה',
        accept: () => {
            payment.SpecialPayment_ChargeByWholeReminder = true;
            this.chargeSingle(payment);
        },
        reject: () => {
            console.log('no');
        }
    });
  }

  vfInit(payment: Payment) {
    this.tripService.changeCardInit2(payment, this.selectedCid, this.selectedSid, this.selectedCatid, this.selectedStatusid?this.selectedStatusid:0, this.selectedGrouperName ).subscribe((result: any) => {
      let url = result;
      if (url && url != '') {
        window.location.href = url;
      } else {
        this.showMessage('error', '', 'תקלה באתחול פעולת החלפת כרטיס');
      }
      
    },
      (err: HttpErrorResponse) => {
        this.isActionButtonsDisabled = false;
        this.showMessage('error', '', 'תקלה בביצוע פעולת חיוב');
    });
  }




  

  changeNumOfPayments(payment: Payment) {
    this.numOfPaymentsArray = new Array();
    if (payment.MaxPaymentsNumber) {this.numOfPaymentsArray = new Array(payment.MaxPaymentsNumber);}
    this.showNumOfPaymentsDialog = true;
    this.changeNumOfPaymentsDetails = payment;
    this.selectedNumOfPayments = payment.NumOfPayments;
  }

  onHideChangeNumOfPaymentsDialog() {
    this.changeNumOfPaymentsDetails = null;
  }

  updateNumberOfPayments() {

    this.tripService.changeNumOfPayments(this.changeNumOfPaymentsDetails, this.selectedNumOfPayments ).subscribe((result: any) => {
        this.showMessage('info', '', 'מספר תשלומים עודכן');
        this.changeNumOfPaymentsDetails.NumOfPayments = this.selectedNumOfPayments;
        this.showNumOfPaymentsDialog = false;
        this.changeNumOfPaymentsDetails = null;
    },
      (err: HttpErrorResponse) => {
        this.isActionButtonsDisabled = false;
        this.showMessage('error', '', 'תקלה בעדכון מספר תשלומים');
    });

    
  }

  // isShowPayment(item: Payment) {

  //   if (this.selectedBillingStatusId == null) {
  //     return true;
  //   } else if (this.selectedBillingStatusId==1 && (item.BillingStatusId==1 || item.BillingManualStatusId==1)) {
  //     return true;
  //   }  else if (this.selectedBillingStatusId==2 && (item.BillingStatusId==2 && item.BillingManualStatusId!=1)) {
  //     return true;
  //   } else if (this.selectedBillingStatusId==0 && (!item.BillingStatusId && !item.BillingManualStatusId)) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // }

  filterPayments() {
    if (this.selectedBillingStatusId == null) {
      this.paymentsFiltered = this.paymentsOriginal.filter(f=>true);
    } else if (this.selectedBillingStatusId==1) {
      this.paymentsFiltered = this.paymentsOriginal.filter(f=>(f.BillingStatusId==1 || f.BillingManualStatusId==1));
    }  else if (this.selectedBillingStatusId==2) {
      this.paymentsFiltered = this.paymentsOriginal.filter(f=>(f.BillingStatusId==2 && f.BillingManualStatusId!=1));
    } else if (this.selectedBillingStatusId==0) {
      this.paymentsFiltered = this.paymentsOriginal.filter(f=>(!f.BillingStatusId && !f.BillingManualStatusId));
    } else if (this.selectedBillingStatusId==9) {
      this.paymentsFiltered = this.paymentsOriginal.filter(f=>(!f.BillingStatusId && !f.BillingManualStatusId) || (!f.isCanceled && f.TravelersCanceledInPayment>0) || (!f.isCanceled && f.BillingStatusId==2));
    } else {
      this.paymentsFiltered = null;
    }

    if (this.paymentsFiltered) {
      if (this.selectedCancel == null) {
        // הכל
      } else if (this.selectedCancel == 0) {
        // פעילים בלבד
        this.paymentsFiltered = this.paymentsFiltered.filter(f=>(!f.isCanceled));
      } else if (this.selectedCancel == 1) {
        // השתתפות מבוטלת בלבד
        this.paymentsFiltered = this.paymentsFiltered.filter(f=>(f.isCanceled));
      } else if (this.selectedCancel == 3) {
        // שולם אבל קיימים משתתפים מבוטלים
        this.paymentsFiltered = this.paymentsFiltered.filter(f=>(!f.isCanceled && f.TravelersCanceledInPayment>0));
      }

      if (this.selectedPaymentsExecuted == null) {
        // ללא סינון לפי מסםר חיובים
      } else if (this.selectedPaymentsExecuted==99) {
        this.paymentsFiltered = this.paymentsFiltered.filter(f=>(f.SpecialPayment_NumberOfPaymentsExecuted>4));
      } else {
        this.paymentsFiltered = this.paymentsFiltered.filter(f=>(f.SpecialPayment_NumberOfPaymentsExecuted==this.selectedPaymentsExecuted));
      }
    }

    
  }

  showSpecialPaymentsMethod1Dialog(item: Payment) {
    this.currentSpecialMethodPaymentItem = item;
    this.showSpecialPaymentsMethod1 = true;
  }

  hideSpecialPaymentsMethod1Dialog() {
    this.currentSpecialMethodPaymentItem = null;
    this.showSpecialPaymentsMethod1 = false;
  }


  clone(o) {
    return JSON.parse(JSON.stringify(o));
  }

  
}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/Pensioner/PensionerPnoCharger/PnoCharger/Client/src/app/trip-cycle-details-2/trip-cycle-details-2.component.ts